import { OrganizationalUnitsRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: OrganizationalUnitsRepository,
): Interactor {
  return ({ planzone, organizationalUnit }) =>
    present(
      repository
        .saveOrganizationalUnit(organizationalUnit)
        .then((savedOrganizationalUnit) => {
          const resources = organizationalUnit.resources ?? [];

          return (
            resources.length > 0
              ? repository.assignResourcesToOrganizationalUnit(
                  savedOrganizationalUnit,
                  resources.map(({ uuid }) => uuid),
                )
              : Promise.resolve([])
          ).then((assignedUuids) => ({
            ...savedOrganizationalUnit,
            resources: resources
              .filter(({ uuid }) => assignedUuids.includes(uuid))
              .map((resource) => ({
                ...resource,
                organizationalUnit: {
                  uuid: savedOrganizationalUnit.uuid,
                  name: savedOrganizationalUnit.name,
                  rankKey: savedOrganizationalUnit.rankKey,
                  parentUuid: savedOrganizationalUnit.parentUuid,
                },
              })),
          }));
        })
        .then((savedOrganizationalUnit) => ({
          planzone,
          organizationalUnit: savedOrganizationalUnit,
        }))
        .catch(() =>
          Promise.reject({
            planzone,
            organizationalUnit,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
